<template>
  <main>
    <HeaderNews
        buttonTitle="Editar"
        buttonTitle2="Excluir"
        title="Notícias"
        text=""
        @voltar="goToRoute('/noticias')"
        :haveAction="false"
        :haveBack="true"
    />
    <v-container style="max-width: unset" class="pa-4">
      <section>
        <v-img
            :src="news.image"
            style="border-radius: 2px !important;"
            height="180"
            width="300"
        >
        </v-img>
      </section>

      <v-row cols="12">
        <v-col class="" cols="12">
          <h1>{{news.title}}</h1>
        </v-col>
      </v-row>

      <v-row cols="12">
        <v-col class="" cols="12">
          <p v-html="news.description"></p>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>

<style scoped>
.delete-photo {
  cursor: pointer;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}

.edit-photo {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
}

.photo-field {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px !important;
  height: 180px;
  background: #dadada;
  cursor: pointer;
  transition: 0.1s;
  box-sizing: border-box;
  border-radius: 5px !important;
}

@media (max-width: 600px) {
  .image-container {
    width: 200%;
  }
}

@media (max-width: 900px) {
  .image-container {
    width: 200%;
  }
}

@media (max-width: 300px) {
  .image-container {
    width: 145%;
  }
}

.cancel-button {
  border-radius: 7.5px !important;
  transition: 0.3s !important;
}

.cancel-button:hover {
  color: white !important;
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2) !important;
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import moment from "moment";
import HeaderNews from "./HeaderNews";

export default {
  components: {
    HeaderNews
  },
  data: () => ({
    imageKey: 0,
    newsId: null,
    loading: false,
    apiService: new ApiService(),
    news: {
      title: null,
      image: null,
      description: null,
    }
  }),
  async mounted() {
    this.newsId = this.$route.query.id
    await this.getNews()
  },
  methods: {
    showPhoto(image) {
      if (!!image && image.includes("Uploads/")) {
        const env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    async getNews() {
      try {
        this.apiService
            .get(`news/get-one?id=${this.newsId}`)
            .then((response) => {
              this.news = response.content;
            })
            .catch((error) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: `${error.message ? error.message : 'Não foi possível atualizar a notícia'}`,
                trace: null,
              });
            })

      } catch (error) {
      }
    }
  },

  watch: {},
};
</script>
